import { useEffect, useState } from "react";

import type { RefObject } from "react";

export const useTextOverflow = (ref: RefObject<HTMLElement>) => {
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    setHasOverflow(element.scrollWidth > element.clientWidth);
  }, []);

  return hasOverflow;
};
